const helpers = {};

helpers.formatNameSurname = (val, shouldTrim = false) => {
  if (!val) return '';

  let formatted = val.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑüÜ '\-’]+/g, '');
  if (shouldTrim) {
    // Triggers when we focus out the field
    formatted = formatted
      .replace(/\s+/g, ' ')
      .replace(/(?:^|\s)\S/g, (c) => c.toUpperCase())
      .trim();
  }

  return formatted;
};

export default helpers;
